<div class="body-container-zone">
    <form [formGroup]="filterForm">
        <div class="row">
            <div class="form-group col-lg-3">
                <app-dropdown-selector
                    [items]="sector"
                    [label]="'Sector'"
                    bindLabel="name"
                    bindValue="id"
                    [placeholder]="'select-sector' | lang"
                    [clearable]="false"
                    formControlName="levelTwo"
                ></app-dropdown-selector>
            </div>
            <div class="form-group col-lg-3">
                <app-dropdown-selector
                    class="mr-3 pt-1"
                    [items]="street"
                    [label]="'street' | lang"
                    bindLabel="name"
                    bindValue="id"
                    [placeholder]="'select-street' | lang"
                    [clearable]="false"
                    [clearOnFill]="isCleared"
                    formControlName="levelThree"
                ></app-dropdown-selector>
            </div>
            <div class="form-group col-lg-3">
                <app-input
                    class="mr-3 pt-1"
                    [theme]="'light'"
                    [displayIcon]="true"
                    [maxCharLength]="25"
                    [placeholder]="'insert-ditch' | lang"
                    [size]="'large'"
                    [clearable]="false"
                    [label]="'ditch' | lang"
                    [inputType]="'search'"
                    formControlName="search"
                ></app-input>
            </div>
            <div class="d-inline-flex">
                <app-button
                    class="action shadowed rounded mt-3"
                    [text]="'filter'"
                    (click)="filterData()"
                ></app-button>
                <app-button
                    class="cancel shadowed rounded mt-3"
                    [text]="'clear-filter'"
                    (click)="reset()"
                ></app-button>
            </div>
        </div>
    </form>
    <app-main-table [tableConfig]="tableConfig" *ngIf="tableConfig">
    </app-main-table>
</div>
